import { html, TemplateResult } from 'lit';
import { cleaningServicePriceInCents } from '../../../constants';
import { formatLongDate } from '../../../helpers/date';
import { formatNumber } from '../../../helpers/number';
import { subTotalInCents } from '../../../helpers/subtotal';
import { staticText } from '../../../static-text';
import { BookingRequest } from '../../../types/booking-request';
import { WPHousePosts } from '../../../types/wp-data';

export function reservationSummary(
	state: BookingRequest,
	posts: WPHousePosts
): TemplateResult {
	const currentPost = posts.find( ( post ) => {
		return post.id === state.bookingData.houseId;
	} );

	if ( !currentPost ) {
		throw new Error( `When you are showing this step, the WP House Post should be available. state.bookingData.houseId is ${state.bookingData.houseId} and cannot be found inside the WP House Posts` );
	}

	let numberOfPersonsLabel = staticText.manyPersons( state.bookingData.numberOfPersons );
	if ( 1 === state.bookingData.numberOfPersons ) {
		numberOfPersonsLabel = staticText.onePerson;
	}

	const startOfStay = state.bookingData.startOfStay;
	if ( !startOfStay ) {
		throw new Error( 'When you are showing this step, the start of stay should be available.' );
	}
	const endOfStay = new Date( startOfStay.toISOString() );
	endOfStay.setUTCDate( endOfStay.getUTCDate() + state.bookingData.numberOfNights );

	const nightsOverviewRows: TemplateResult[] = [];
	state.bookingData.weekData?.weeks.forEach( ( week ) => {
		nightsOverviewRows.push(
			html`
				<tr>
					<th class="reservation-summary__key">
						${staticText.priceWeek( week )}
					</th>
					<td class="reservation-summary__value">
						${formatPrice( week.priceInEuroCents )}
					</td>
				</tr>
			`
		);
	} );

	return html`
		<table class="reservation-summary type-f">
			<tr>
				<th class="reservation-summary__key">
					${staticText.property}
				</th>
				<td class="reservation-summary__value">
					${currentPost.title}
				</td>
			</tr>
			<tr>
				<th class="reservation-summary__key">
					${staticText.arrivalDate}
				</th>
				<td class="reservation-summary__value">
					${formatLongDate( startOfStay )}
				</td>
			</tr>
			<tr>
				<th class="reservation-summary__key">
					${staticText.departureDate}
				</th>
				<td class="reservation-summary__value">
					${formatLongDate( endOfStay )}
				</td>
			</tr>
			<tr>
				<th class="reservation-summary__key">
					${staticText.numberOfPersonsHash}
				</th>
				<td class="reservation-summary__value">
					${numberOfPersonsLabel}
				</td>
			</tr>
			${nightsOverviewRows}
			<tr>
				<th class="reservation-summary__key">
					${staticText.priceCleaningCost}
				</th>
				<td class="reservation-summary__value">
					€ ${formatNumber( cleaningServicePriceInCents )}
				</td>
			</tr>
			<tr>
				<th class="reservation-summary__key">
					${staticText.totalCost}
				</th>
				<td class="reservation-summary__value">
					€ ${formatNumber( subTotalInCents( state.bookingData.weekData, cleaningServicePriceInCents ) )}
				</td>
			</tr>
		</table>
	`;
}

function formatPrice( price: number | undefined ): TemplateResult {
	if ( !price ) {
		return html``;
	}

	return html`€ ${formatNumber( price )}`;
}
